import { useEffect } from 'react';

interface HelmetProps {
  title: string;
  description: string;
  canonicalUrl: string;
  imageUrl?: string;
  type?: string;
}

export function Helmet({ title, description, canonicalUrl, imageUrl, type = 'website' }: HelmetProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', type, true);
    setMeta('og:url', `${window.location.origin}${canonicalUrl}`, true);
    if (imageUrl) {
      setMeta('og:image', imageUrl, true);
    }
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:card', 'summary_large_image');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${window.location.origin}${canonicalUrl}`);

    return () => {
      document.title = originalTitle;
    };
  }, [title, description, canonicalUrl, imageUrl, type]);

  return null;
}